import {Component} from "react";
import * as React from "react";
import {LabeledField} from "./LabeledField"

class BoxedField extends Component {

    constructor(props) {
        super(props)
        this.updateValue = this.updateValue.bind(this)
    }

    updateValue(value) {
        this.props.onValueChanged(this.props.name,value)
    }

    render() {
        return <div className={"boxed-field"}>
            <LabeledField
                placeholder={this.props.placeholder}
                label={this.props.label}
                updateValue={this.updateValue}
                value={this.props.value}
                inputType={this.props.inputType}
                setFullHeight={this.props.setFullHeight}
          />
        </div>
    }
}

export {BoxedField}